
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import BrandPhilosophy from './components/BrandPhilosophy';
import ChairSection from './components/ChairSection';
import DeskSection from './components/DeskSection';
import GadgetSection from './components/GadgetSection';
import CraftTeaBanner from './components/CraftTeaBanner';
import RentalSection from './components/RentalSection';
import AboutSection from './components/AboutSection';
import FinalCTA from './components/FinalCTA';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CampaignBanner from './components/CampaignBanner';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <div className="pt-20">
        <CampaignBanner />
      </div>
      <Hero />
      <ProductShowcase />
      <BrandPhilosophy />
      <ChairSection />
      <DeskSection />
      <GadgetSection />
      <CraftTeaBanner />
      <RentalSection />
      <AboutSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}
